module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av53-d693c4d6850a36d376743d10e13ea998.jpg";